import { useWindowSize } from 'hooks/useWindowSize';

const VOX_VIEWER_URL = 'https://voxviewer.azureedge.net';

interface VoxViewerProps {
  model: string;
  width?: number | string;
  height?: number | string;
}

const VoxViewer = ({ model, width, height }: VoxViewerProps) => {
  const ws = useWindowSize();
  const size = ws.width < 480 ? (ws.width - 10) : 480;

  return (
    <iframe
      src={`${VOX_VIEWER_URL}?model=${model}`}
      width={ width || size}
      height={height || size}
      frameBorder="0"
      title="Futura mixpass"
      scrolling="no"
    />
  );
}

export default VoxViewer;
